const END_DEVICE_STATES_UPDATED = (state, device_states) => {
  state.device_states = device_states
  console.log('end-device states mutation set')
}

const END_DEVICE_STATE_UPDATED = (state, device_state) => {
  state.device_state = device_state
}

const END_DEVICE_LIST_VIEW_UPDATED = (state, device_list_view) => {
  state.device_list_view = device_list_view
}

const END_DEVICE_REVISIONS_UPDATED = (state, device_revisions) => {
  state.device_revisions = device_revisions
}

const END_DEVICE_REVISIONS_VIEW_UPDATED = (state, device_revisions_view) => {
  state.device_revisions_view = device_revisions_view
}

const DEVICE_PROFILE_REVISIONS_UPDATED = (state, profile_revisions) => {
  state.profile_revisions = profile_revisions
}

const DEVICE_PROFILE_REVISIONS_VIEW_UPDATED = (state, profile_revisions_view) => {
  state.profile_revisions_view = profile_revisions_view
}

const OPERATIONS_UPDATED = (state, operations) => {
  state.operations = operations
}

const OPERATIONS_VIEW_UPDATED = (state, operations_view) => {
  state.operations_view = operations_view
}

const OPERATIONS_REMOVE_ITEM = (state, id) => {
  let i = state.operations.data.findIndex(item => {item.id === id})
  state.operations.data.splice(i, 1)
  state.operations_view.total--
}

const OPERATIONS_ADD_ITEM = (state, user) => {
  state.operations.data.push(user)
  state.operations_view.total++
}

const OPERATION_DEVICES_UPDATED = (state, operation_devices) => {
  state.operation_devices = operation_devices
}

const OPERATION_DEVICES_VIEW_UPDATED = (state, operation_devices_view) => {
  state.operation_devices_view = operation_devices_view
}

const OPERATION_DEVICES_STATUS_UPDATED = (state, operation_status) => {
  state.operation_status = operation_status
}

export default {
  END_DEVICE_STATES_UPDATED,
  END_DEVICE_STATE_UPDATED,
  END_DEVICE_LIST_VIEW_UPDATED,
  END_DEVICE_REVISIONS_UPDATED,
  END_DEVICE_REVISIONS_VIEW_UPDATED,
  DEVICE_PROFILE_REVISIONS_UPDATED,
  DEVICE_PROFILE_REVISIONS_VIEW_UPDATED,
  OPERATIONS_UPDATED,
  OPERATIONS_VIEW_UPDATED,
  OPERATIONS_REMOVE_ITEM,
  OPERATIONS_ADD_ITEM,
  OPERATION_DEVICES_UPDATED,
  OPERATION_DEVICES_VIEW_UPDATED,
  OPERATION_DEVICES_STATUS_UPDATED
}



// WEBPACK FOOTER //
// ./src/modules/endDeviceStates/store/mutations.js